import { Link } from 'gatsby'
import type { ReactNode } from 'react'

export const WrapperElement = ({
  children,
  enableCardLink,
  className,
  productLink,
}: {
  className?: string
  children: ReactNode
  enableCardLink: boolean
  productLink: { to: string; onClick: () => void; 'data-testid': string }
}) => {
  return enableCardLink ? (
    <Link {...productLink} className={className ?? ''}>
      {children}
    </Link>
  ) : (
    <div className={className ?? ''}>{children}</div>
  )
}
